<template>
  <div>
    <div class="panel" v-if="!productTemplateId">
      <div class="filter">
        <el-form
          :inline="true"
          :model="filter"
          ref="filterForm"
          label-position="right"
          label-width="90px"
          class="search-form"
          size="small"
        >
          <el-form-item label="编号">
            <el-input v-model="filter.code" placeholder="搜索编号"></el-input>
          </el-form-item>
          <el-form-item label="关键字">
            <el-input
              v-model="filter.query"
              placeholder="搜索自定义属性值"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <ItemStatusSelect
              v-model="filter.status"
              model="product"
              :clearable="true"
              blankLabel="全部（不含报废和灭失）"
            ></ItemStatusSelect>
          </el-form-item>
          <el-form-item label="寿命预警">
            <ItemStatusSelect
              v-model="filter.lifewarning"
              model="lifewarning"
              :clearable="true"
              blankLabel="不限"
            ></ItemStatusSelect>
          </el-form-item>
          <el-form-item label="使用时长">
            <el-select v-model="filter.hour_step">
              <el-option key="0" label="不限" value="0"></el-option>
              <el-option
                v-for="(k, v) in ProductHourStepMap"
                :key="k"
                :label="k"
                :value="v"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="组装基地">
            <BaseSelect
              v-model="filter.install_base_id"
              :clearable="true"
            ></BaseSelect>
          </el-form-item>
          <el-form-item label="发往基地" v-if="category == 1">
            <BaseSelect v-model="filter.base_id" :clearable="true"></BaseSelect>
          </el-form-item>
          <el-form-item label="库存基地" v-if="category == 2">
            <BaseSelect
              v-model="filter.base_ids"
              :clearable="true"
              :filterBlank="true"
            ></BaseSelect>
          </el-form-item>
          <el-form-item label="库存状态" v-if="category == 2">
            <el-select v-model="filter.stock_status">
              <el-option :key="0" :value="0" label="全部"></el-option>
              <el-option :key="1" :value="1" label="待入库"></el-option>
              <!-- <el-option :key="2" :value="2" label="待回收确认"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item label="待入库基地" v-if="category == 2">
            <BaseSelect
              v-model="filter.receive_base_id"
              :clearable="true"
              :filterBlank="true"
            ></BaseSelect>
          </el-form-item>
          <el-form-item label="发往钻井" v-if="category == 2">
            <DrillWellSelect
              v-model="filter.drill_well_id"
              :clearable="true"
            ></DrillWellSelect>
          </el-form-item>
          <el-form-item label="创建时间" prop="date">
            <el-date-picker
              v-model="filter.date"
              unlink-panels
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div style="margin-left: 90px">
          <el-button type="primary" size="small" @click="productQuery()"
            >筛选</el-button
          >
          <el-button size="small" @click="productQuery(true)">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel" v-if="waringList.length > 0 && !productTemplateId">
      <el-link class="text-danger" :underline="false">寿命预警：</el-link>
      <el-link
        :underline="false"
        v-for="item in waringList"
        :key="item.template_id"
        class="mr-5"
        @click="
          filter.group_name = ''
          productQuery(true, item.template_id)
        "
        >{{ item.template_name
        }}<span class="text-danger" style="margin-left: -5px"
          >（{{ item.count }}）</span
        ></el-link
      >
    </div>

    <div class="panel temp-filter" v-if="!productTemplateId">
      <div class="group-container" v-if="groups.length > 1">
        <span
          class="mr-10 mb-10 pointer"
          :key="group.id"
          :class="{ active: group.id == activeTab }"
          @click="handleGroupClick(group.id)"
          v-for="group in groups"
          >{{ group.name }}
        </span>
      </div>
      <div
        class="group-container"
        style="padding-bottom: 10px"
        :value="selectedTemp.id"
        v-if="selectedTemp"
      >
        <draggable
          class="temp-list"
          :list="groupTemplates"
          ghost-class="ghost"
          @update="itemDragUpdate"
          :disabled="user.id != 1 && user.id != 27"
        >
          <el-tag
            size="small"
            class="pointer"
            :key="temp.id"
            :effect="temp.id == selectedTemp.id ? 'light' : 'plain'"
            :type="temp.id == selectedTemp.id ? 'primary' : 'info'"
            @click="handleTemplateChange(temp.id)"
            v-for="temp in groupTemplates"
            >{{ temp.name
            }}<span class="cus-badge" v-if="temp.stocking_count">{{
              temp.stocking_count
            }}</span>
          </el-tag>
        </draggable>
      </div>
      <div class="group-container" v-if="childrenGroups.length > 0">
        <span
          @click="handleChildrenGroupClick(item)"
          class="mr-10 mb-10 pointer"
          :class="{ active: filter.group_name == item }"
          v-for="item in childrenGroups"
          :key="item"
          >{{ item || '不限' }}</span
        >
      </div>
    </div>

    <!-- <div class="panel" v-if="!productTemplateId">
      <el-select
        size="small"
        filterable
        :value="activeTab"
        @change="handleGroupClick"
      >
        <el-option
          v-for="group in groups"
          :key="group.id"
          :label="group.name"
          :value="group.id"
        ></el-option>
      </el-select>
      <el-select
        filterable
        class="ml-5"
        size="small"
        :value="selectedTemp.id"
        @change="handleTemplateChange"
        v-if="selectedTemp"
      >
        <el-option
          v-for="item in groupTemplates"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        filterable
        class="ml-5"
        size="small"
        v-model="filter.group_name"
        clearable
        @change="productQuery()"
        v-if="selectedTemp && selectedTemp.children_groups"
      >
        <el-option
          v-for="item in (selectedTemp.children_groups || '').split('、')"
          :key="item"
          :label="item"
          :value="item"
        ></el-option>
      </el-select>
    </div> -->

    <!-- <div v-if="!productTemplateId" class="panel">
      <el-dropdown
        placement="bottom-start"
        trigger="click"
        @command="handleGroupClick"
      >
        <span class="el-dropdown-link">
          {{ activeTab ? groups.find((i) => i.id == activeTab).name : '请选择'
          }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="group in groups"
            :key="`g${group.id}`"
            :command="group.id"
            >{{ group.name }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown
        placement="bottom-start"
        class="ml-20"
        v-if="selectedTemp"
        trigger="click"
        @command="handleTemplateChange"
      >
        <span class="el-dropdown-link">
          {{ selectedTemp ? selectedTemp.name : '请选择'
          }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="item in groupTemplates"
            :command="item.id"
            :key="`t${item.id}`"
            >{{ item.name }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown
        placement="bottom-start"
        class="ml-20"
        v-if="selectedTemp && selectedTemp.children_groups"
        trigger="click"
        @command="
          filter.group_name = $event
          productQuery()
        "
      >
        <span class="el-dropdown-link">
          {{ filter.group_name || '请选择'
          }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="item in selectedTemp.children_groups.split('、')"
            :key="item"
            :command="item"
            >{{ item }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div> -->

    <div :class="{ panel: !productTemplateId }" v-if="templates">
      <!-- <template v-if="!productTemplateId">
        <el-tabs
          :activeName="activeTab"
          @tab-click="handleGroupClick"
          v-if="groups.length > 1"
        >
          <el-tab-pane
            :label="item.name"
            :name="item.id.toString()"
            v-for="item in groups"
            :key="item.id"
          ></el-tab-pane>
        </el-tabs>
        <draggable
          :list="groupTemplates"
          ghost-class="ghost"
          @update="itemDragUpdate"
          :disabled="user.id != 1 && user.id != 27"
        >
          <el-tag
            class="mr-10 mb-10 pointer"
            :key="temp.id"
            :effect="temp.id == selectedTemp.id ? 'light' : 'plain'"
            :type="temp.id == selectedTemp.id ? 'primary' : 'info'"
            @click="getProductData(temp, 1)"
            v-for="temp in groupTemplates"
            >{{ temp.name
            }}<span class="cus-badge" v-if="temp.stocking_count">{{
              temp.stocking_count
            }}</span>
          </el-tag>
        </draggable>

        <el-empty
          description="暂无数据，请先添加成品分类"
          v-if="templates.length == 0 && !productTemplateId"
        ></el-empty>
      </template> -->
      <ItemTable
        :template="selectedTemp"
        :canTransfer="true"
        :addDisabled="
          childrenGroups.length > 0 &&
          (!filter.group_name || filter.group_name == '其他')
        "
        v-if="selectedTemp"
        :filter="filter"
        ref="itemTable"
        @baseCheck="handleBaseCheck"
      ></ItemTable>
    </div>
  </div>
</template>

<script>
import {
  productTemplateList,
  productTemplateSort,
  productList,
} from '@/service/getData'
import ItemTable from './table'
import draggable from 'vuedraggable'
import { ProductHourStepMap } from '@/config/global'
import store from '@/store/index'

export default {
  props: {
    category: {
      type: Number,
      default: 0,
    },
    productTemplateId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    ItemTable,
    draggable,
  },
  data() {
    return {
      ProductHourStepMap,
      selectedTemp: null,
      templates: null,
      waringList: [],
      filter: {
        category: this.category,
        hour_step: '0',
        code: '',
        query: '',
        date: '',
        group_name: '',
        lifewarning: 0,
        base_id: 0,
        base_ids: [],
        status: 0,
        stock_status: 0,
        drill_well_id: 0,
        receive_base_id: 0,
        install_base_id: 0,
        product_template_id: 0,
        page: 1,
        size: 10,
      },
      user: store.state.userInfo,
      groups: [],
    }
  },
  computed: {
    activeTab() {
      if (!this.selectedTemp) return ''
      return this.selectedTemp.template_group_id
    },
    groupTemplates() {
      if (!this.templates) return []
      return this.templates
        .filter((item) => item.template_group_id == this.activeTab)
        .sort(function (a, b) {
          return a.sort - b.sort
        })
    },
    childrenGroups() {
      if (this.selectedTemp && this.selectedTemp.children_groups) {
        return ['']
          .concat(this.selectedTemp.children_groups.split('、'))
          .concat(['其他'])
      } else {
        return []
      }
    },
  },
  created() {
    if (this.$route.query.filter) {
      let filter = JSON.parse(this.$route.query.filter)
      if (!filter.hasOwnProperty('group_name')) {
        filter.group_name = ''
      }
      this.filter = filter
    }

    if (this.$route.query.product_template_id) {
      this.filter.product_template_id = parseInt(
        this.$route.query.product_template_id,
      )
    }

    if (this.$route.query.hour_step) {
      this.filter.hour_step = this.$route.query.hour_step
    }

    this.getData()
  },
  methods: {
    handleBaseCheck() {
      if (this.productTemplateId == 0 && this.category == 2) {
        let currentTemp = this.templates.find(
          (temp) => temp.id === this.selectedTemp.id,
        )
        let index = this.templates.indexOf(currentTemp)
        this.templates[index].stocking_count--
      }
    },
    async getWaringData() {
      if (this.productTemplateId) {
        return
      }
      let res = await productList({
        category: this.category,
        warning_statistic: true,
      })
      if (res.code == 0) {
        this.waringList = res.data.list
      }
    },
    handleGroupClick(e) {
      this.filter.group_name = ''
      const temp = this.templates.filter((i) => i.template_group_id == e)[0]
      this.getProductData(temp, 1)
    },
    handleTemplateChange(id) {
      this.filter.group_name = ''
      this.getProductData(
        this.groupTemplates.find((i) => i.id == id),
        1,
      )
    },
    handleChildrenGroupClick(item) {
      this.filter.group_name = item
      this.productQuery()
    },
    async getData() {
      let res = await productTemplateList({
        page: 0,
        size: 1000,
        category: this.category,
        id: this.productTemplateId,
        order_sort: true,
        stocking_count: this.productTemplateId == 0 && this.category == 2,
        code_type: 1,
      })
      this.templates = res.data.list

      let groups = []
      this.templates.map((temp) => {
        if (!groups.find((item) => item.id == temp.template_group_id)) {
          groups.push({
            id: temp.group.id,
            name: temp.group.name,
            sort: temp.group.sort,
          })
        }
      })

      groups.sort(function (a, b) {
        if (a.sort == b.sort) {
          return a.id - b.id
        } else {
          return a.sort - b.sort
        }
      })

      this.groups = groups

      if (this.templates.length > 0) {
        let selectedTemp =
          this.templates.filter(
            (item) => item.id == this.filter.product_template_id,
          )[0] ||
          this.templates.filter(
            (item) => item.template_group_id == this.groups[0].id,
          )[0]
        this.getProductData(selectedTemp, this.filter.page || 1)
        this.getWaringData()
      }
    },
    getProductData(temp, page = 1) {
      this.selectedTemp = temp
      this.filter.product_template_id = temp.id
      this.filter.page = page

      let _this = this
      this.$nextTick(() => {
        _this.$refs.itemTable.getData()
      })
    },
    productQuery(reset = false, templateId = 0) {
      if (reset) {
        this.filter.code = ''
        this.filter.query = ''
        this.filter.date = ''
        this.filter.hour_step = '0'
        this.filter.base_id = 0
        this.filter.base_ids = []
        this.filter.status = 0
        this.filter.lifewarning = 0
        this.filter.stock_status = 0
        this.filter.drill_well_id = 0
        this.filter.receive_base_id = 0
        this.filter.install_base_id = 0
      }

      if (templateId) {
        //筛选某个分类的预警
        this.selectedTemp = this.templates.find((item) => item.id == templateId)
        this.filter.product_template_id = templateId
        this.filter.lifewarning = 1
      }

      this.filter.page = 1
      if (this.filter.receive_base_id) {
        this.filter.stock_status = 1
      }
      this.$refs.itemTable.getData()
    },
    async itemDragUpdate() {
      var ids = this.groupTemplates.map((item, index) => {
        item.sort = index + 1
        return item.id
      })
      let res = await productTemplateSort({
        ids: ids,
      })
    },
  },
}
</script>

<style scoped>
.pointer {
  position: relative;
}
.cus-badge {
  position: absolute;
  right: -4px;
  top: -6px;
  background-color: rgb(245, 108, 108);
  color: rgb(255, 255, 255);
  display: inline-block;
  font-size: 10px;
  height: 15px;
  line-height: 12px;
  text-align: center;
  border-radius: 8px;
  padding: 0px 4px;
  white-space: nowrap;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(255, 255, 255);
  border-image: initial;
}

.temp-filter {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.temp-filter .active {
  color: #409eff;
}

.group-container {
  padding-bottom: 5px;
  border-bottom: 1px dashed #eee;
}

.group-container:last-child {
  border-bottom: none;
  padding-bottom: 0 !important;
}

.temp-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
</style>